<header
    class="header-area bg-white border-radius transition"
    [ngClass]="{'active': isSidebarToggled, 'sticky': isSticky}"
    [class.component-dark-theme]="themeService.isDark()"
    [class.right-sidebar]="themeService.isRightSidebar()"
    [class.hide-sidebar]="themeService.isHideSidebar()"
    [class.dark-header]="themeService.isHeaderDark()"
    [class.card-borderd-theme]="themeService.isCardBorder()"
    [class.rtl-enabled]="themeService.isRTLEnabled()"
>
    <div class="d-md-flex align-items-center justify-content-between">
        <div class="header-left-side d-flex align-items-center">
            <div
                class="burger-menu cursor-pointer transition d-xl-none"
                [ngClass]="{'active': isSidebarToggled}"
                (click)="toggle()"
            >
                <span class="top-bar d-block bg-black transition"></span>
                <span class="middle-bar d-block bg-black transition"></span>
                <span class="bottom-bar d-block bg-black transition"></span>
            </div>
            <i class="fa-solid fa-house-chimney mx-3"></i>
            Bienvenue <b class="mx-3">{{user_name}}</b>
        </div>

        <ul class="header-right-side d-flex align-items-center mt-0 mb-0 pl-0 list-unstyled">
            <!--
            <li>
                <button mat-icon-button [matMenuTriggerFor]="languageMenu" class="language-menu-btn">
                    <i class="material-symbols-outlined">
                        translate
                    </i>
                </button>
                <mat-menu class="language-menu-dropdown" #languageMenu="matMenu" xPosition="before">
                    <div
                        [class.dark-menu]="themeService.isDark() || themeService.isHeaderDark()"
                    >
                        <span class="title fw-medium d-block">Choose Language</span>
                        <ul class="menu-body pl-0 mb-0 mt-0 list-unstyled">
                            <li>
                                <button mat-button>
                                    <img src="assets/images/flags/usa.png" alt="flag">
                                    English
                                </button>
                            </li>
                            <li>
                                <button mat-button>
                                    <img src="assets/images/flags/australia.png" alt="flag">
                                    Australian
                                </button>
                            </li>
                            <li>
                                <button mat-button>
                                    <img src="assets/images/flags/spain.png" alt="flag">
                                    Spanish
                                </button>
                            </li>
                            <li>
                                <button mat-button>
                                    <img src="assets/images/flags/france.png" alt="flag">
                                    French
                                </button>
                            </li>
                            <li>
                                <button mat-button>
                                    <img src="assets/images/flags/germany.png" alt="flag">
                                    German
                                </button>
                            </li>
                        </ul>
                    </div>
                </mat-menu>
            </li>
            -->
            <li>
                <button
                    mat-button
                    class="dark-swtich-btn"
                    (click)="toggleTheme()"
                >
                    <i class="material-symbols-outlined">
                        dark_mode
                    </i>
                </button>
            </li>
            <!--
            <li>
                <a routerLink="/calendar" mat-icon-button class="calendar-menu-btn p-0">
                    <i class="material-symbols-outlined">
                        calendar_today
                    </i>
                </a>
            </li>
            -->
            <li>
                <button mat-icon-button [matMenuTriggerFor]="messagesMenu" class="messages-menu-btn p-0"  style="margin-right: 5px;">
                    <i class="material-symbols-outlined">
                        mail
                    </i>
      <span *ngIf="totalUnreadMessages > 0" class="daxa-badge d-inline-block rounded-circle">
    {{ totalUnreadMessages }}
  </span>
                </button>
                <mat-menu class="messages-menu-dropdown" #messagesMenu="matMenu" xPosition="before">
                    <div
                        [class.dark-menu]="themeService.isDark() || themeService.isHeaderDark()"
                    >
                        <div class="menu-footer text-center">
                            <a routerLink="/chat" class="link-btn text-daxa d-inline-block fw-medium">
                                Voir tous les messages
                            </a>
                        </div>
                    </div>
                </mat-menu>
            </li>
            <button mat-icon-button [matMenuTriggerFor]="notificationsMenu" class="notifications-menu-btn p-0" style="position: relative;">
                <i class="material-symbols-outlined">notifications</i>
                
                <span 
                    *ngIf="notifications.length > 0"
                    style="
                        position: absolute;
                        top: 3px;
                        right: 2px;
                        background-color: #007bff;
                        color: white;
                        width: 18px;
                        height: 18px;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        border-radius: 50%;
                        font-size: 11px;
                        font-weight: bold;
                    ">
                    {{ unreadNotifications.length | number:'' }}
                </span>
            </button>
            
            <mat-menu class="notifications-menu-dropdown" #notificationsMenu="matMenu" xPosition="before">
                <div [class.dark-menu]="themeService.isDark() || themeService.isHeaderDark()" >

            <div class="title d-flex align-items-center justify-content-between">
                <span class="fw-medium" >
                    Notifications
                    <span class="daxa-badge d-inline-block rounded-circle">
                        ({{ unreadNotifications.length | number:'2.0' }})
                    </span>
                </span>
                <a (click)="markAllAsReadForUser()" class="link-btn text-daxa" style=cursor:pointer;>  Tout marquer lu
                </a>
        
            </div>
            <ul class="menu-body pl-0 mt-0 list-unstyled">
                        <li class="position-relative" *ngFor="let notif of unreadNotifications" (click)="markAsRead(notif.id, $event)">
                            <div class="icon rounded-circle position-absolute text-center transition">
                                <i class="material-symbols-outlined">sms</i>
                            </div>
                            <span class="sub-title d-block">{{ notif.message }}</span>
                            <span class="time d-block text-body">{{ notif.creationTime }}</span>
                            <i *ngIf="!notif.read" 
                            (click)="markAsRead(notif.id, $event)" 
                            class="material-symbols-outlined position-absolute"
                            style="right: 10px; top: 40px; cursor: pointer; font-size: 18px; color: #007bff;">
                            check_circle
                         </i>
                        </li>
            </ul>
            </div>
            <div class="menu-footer text-center">
                <a 
                routerLink="/notifications" 
                class="link-btn d-inline-block fw-medium"
                [ngClass]="{
                  'dark-footer': themeService.isDark() || themeService.isHeaderDark(),
                  'light-footer': !themeService.isDark()
                }">
                  Voir toutes les notifications
            </a>
        </div>

            </mat-menu>
        
            <li>
                <button mat-button [matMenuTriggerFor]="profileMenu" class="profile-menu-btn">
                    <img src="assets/images/admin.png" alt="profile-image">
                    <span class="status d-inline-block rounded-circle position-absolute"></span>
                </button>
                <mat-menu class="profile-menu-dropdown" #profileMenu="matMenu" xPosition="before">
                    <div
                        [class.dark-menu]="themeService.isDark() || themeService.isHeaderDark()"
                    >
                        <div class="menu-header d-flex align-items-center">
                            <img src="assets/images/admin.png" alt="profile-image">
                            <div class="title">
                                <a routerLink="/my-profile" class="d-inline-block fw-medium">
                                    {{user_name}}
                                </a>
                                <span class="designation d-block text-body">
                                    {{role}}
                                </span>
                            </div>
                        </div>
                        <ul class="menu-body pl-0 mb-0 mt-0 list-unstyled">
                            <li class="position-relative transition fw-medium">
                                <i class="material-symbols-outlined">
                                    person
                                </i>
                                Mon Profile
                                <a routerLink="/my-profile" class="link-btn d-block position-absolute"></a>
                            </li>
                            <li class="position-relative transition fw-medium">
                                <i class="material-symbols-outlined">
                                    settings
                                </i>
                                Réglages
                                <a routerLink="/settings" class="link-btn d-block position-absolute"></a>
                            </li>
                            <!--
                            <li class="position-relative transition fw-medium">
                                <i class="material-symbols-outlined">
                                    info
                                </i>
                                Aide
                                <a routerLink="/settings/connections" class="link-btn d-block position-absolute"></a>
                            </li>-->
                            <li class="position-relative transition fw-medium" (click)="logout()">
                                <i class="material-symbols-outlined">
                                    logout
                                </i>
                                Déconnexion
                                <a routerLink="/authentication/logout" class="link-btn d-block position-absolute"></a>
                            </li>
                        </ul>
                    </div>
                </mat-menu>
            </li>
        </ul>
    </div>
</header>
